createSetLikeWithInfinitySize